// extracted by mini-css-extract-plugin
module.exports = {"header":"InstitutionListView_header__3p7yW","add":"InstitutionListView_add__38ANQ","results":"InstitutionListView_results__1wT97"};